import React from 'react';
import { bool, string, func, oneOf, node, shape } from 'prop-types';
import Dialog from '../../../atoms/Dialog';
import Sidebar from '../../../organisms/Sidebar';
import LuContentHeader from '../LuContentHeader';
import LuContentContext from '../LuContentContext';
import { LuDetailContent, Content } from './LuDetail.styles';

const Wrapper = ({
  children,
  title,
  visible,
  onBackButtonClick,
  direction
}) => direction === 'center' ? /*#__PURE__*/React.createElement(Dialog, {
  title: title,
  visible: visible,
  onClickOutside: onBackButtonClick,
  position: "center",
  p: "unset",
  my: "4em"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    width: '100%'
  }
}, children)) : /*#__PURE__*/React.createElement(Sidebar, {
  direction: direction,
  title: title,
  visible: visible,
  onClickOutside: onBackButtonClick,
  fullScreen: true
}, children);

const LuDetail = ({
  direction,
  title,
  subtitle,
  content,
  onBackButtonClick,
  images,
  visible,
  iconHeaderClose
}) => {
  return /*#__PURE__*/React.createElement(LuContentContext, {
    value: {
      images
    }
  }, /*#__PURE__*/React.createElement(Wrapper, {
    direction: direction,
    title: title,
    visible: visible,
    onBackButtonClick: onBackButtonClick
  }, /*#__PURE__*/React.createElement(LuContentHeader, {
    title: title,
    subtitle: subtitle,
    showBackButton: true,
    onBackButtonClick: onBackButtonClick,
    iconName: iconHeaderClose
  }), /*#__PURE__*/React.createElement(LuDetailContent, {
    "data-testid": "lu-detail-content"
  }, /*#__PURE__*/React.createElement(Content, {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }))));
};

LuDetail.defaultProps = {
  direction: 'right',
  content: '',
  images: {},
  onBackButtonClick: () => {},
  subtitle: null,
  title: '',
  visible: false,
  iconHeaderClose: 'ArrowBack'
};
process.env.NODE_ENV !== "production" ? LuDetail.propTypes = {
  content: string,
  direction: oneOf(['right', 'center']),
  images: shape({}),
  onBackButtonClick: func,
  subtitle: string,
  title: string,
  visible: bool,
  iconHeaderClose: string
} : void 0;
process.env.NODE_ENV !== "production" ? Wrapper.propTypes = {
  children: node,
  onBackButtonClick: func,
  title: string,
  visible: bool,
  direction: string
} : void 0;
export default LuDetail;